import { addDays, parseISO, startOfDay } from 'date-fns';

export function inclusiveDateRangeToCalendarEvent(startDate: string, endDate: string) {
  const start = startOfDay(parseISO(startDate));
  const end = addDays(startOfDay(parseISO(endDate)), 1);
  return { start, end, allDay: true as const };
}
